import { Calendar, Crown, Unlock } from 'lucide-react';
import { Badge } from '../ui/badge';
import { getDifficultyLabel } from '../../utils/constants';

const goalLabels = {
  weight_loss: 'Weight Loss', muscle_building: 'Muscle Building', endurance: 'Endurance',
  general_fitness: 'General Fitness', ultimate_fitness: 'Ultimate Fitness',
  strength: 'Strength', core_strength: 'Core Strength',
};

export const ProgramHeroBanner = ({ program, hasAccess, isAdmin, isPremium, purchased }) => (
  <div className="relative h-64 mb-8 overflow-hidden">
    <img src={program.image_url} alt={program.title} className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" />
    <div className="absolute bottom-0 left-0 right-0 p-8">
      <div className="flex items-center gap-3 mb-3 flex-wrap">
        <Badge className="bg-primary/20 text-primary border border-primary/30">
          {goalLabels[program.goal] || program.goal}
        </Badge>
        <Badge className="bg-white/10 text-white border border-white/20">
          {getDifficultyLabel(program.difficulty)}
        </Badge>
        <Badge className="bg-white/10 text-white border border-white/20">
          <Calendar className="h-3 w-3 mr-1" />
          {program.duration_weeks} Weeks
        </Badge>
        {hasAccess && (
          <Badge className="bg-green-500/20 text-green-400 border border-green-500/30">
            {isPremium && !purchased && !isAdmin ? (
              <><Crown className="h-3 w-3 mr-1" /> Premium Unlocked</>
            ) : isAdmin ? (
              <><Unlock className="h-3 w-3 mr-1" /> Admin Access</>
            ) : (
              <><Unlock className="h-3 w-3 mr-1" /> Purchased</>
            )}
          </Badge>
        )}
      </div>
      <h1 className="font-heading text-4xl md:text-5xl text-white uppercase tracking-wider">{program.title}</h1>
    </div>
  </div>
);
